import styled from 'styled-components';
import { Container } from 'components/domain/container';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';

export const FdrCatalogsContainer = styled(Container)(({ theme }) =>
  sx2CssThemeFn({
    px: [0, 4],
    '> button': {
      top: ['auto', '563px'],
      bottom: ['200px', 'auto'],
      width: 'auto',
      zIndex: '10',
      right: 0,
      borderRadius: '5px 0 0 5px',
    },
    button: {
      width: 'fit-content',
    },
    '.catalog-links': {
      button: {
        borderRadius: '5px',
        '&:hover, &:active': {
          background: theme.colors.redHover,
          color: theme.colors.white,
        },
      },
    },
  })
);
